import React, { useState, useEffect, useRef } from 'react';
// import debounce from 'lodash.debounce';
import _ from 'lodash';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,} from '@mui/material';
import CustomInput from '../../CustomInput';
// import CustomSelect from '../../CustomSelect';
import 'react-quill/dist/quill.snow.css';
import CustomButton from '../../CustomButton';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import Underline from '@tiptap/extension-underline';
import { Popover } from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import TextAlign from '@tiptap/extension-text-align';
import Link from '@tiptap/extension-link';
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import EmojiPicker from 'emoji-picker-react'
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import LinkIcon from '@mui/icons-material/Link';
import UndoIcon from '@mui/icons-material/Undo';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import RedoIcon from '@mui/icons-material/Redo';
import { colors, MESSAGE_CHARACTER_LIMIT } from '../../../Config/globalConstants';
import PlusControlledSelect from '../../PlusControlledSelect';


const EmailModal = ({ open, to, cc, subject, message, attachment, onClose, onSend, onFieldChange, contactOptions, supplierOptions}) => {
  const [charCount, setCharCount] = useState(0);
  const [showLimitWarning, setShowLimitWarning] = useState(false);
  const [showConfirmClose, setShowConfirmClose] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [highlightAnchor, setHighlightAnchor] = useState(null);
  
  const resetFields = () => {
    onFieldChange('to', '');
    onFieldChange('cc', '');
    onFieldChange('subject', '');
    onFieldChange('attachment', false);
    onFieldChange('message', ''); // or editor.commands.clearContent() if using a rich editor
    editor?.commands?.clearContent?.(); // optional safe check
  };
  // Use a ref to track previous content to prevent update loops
  const prevMessageRef = useRef(message || '');
  const CHARACTER_LIMIT = MESSAGE_CHARACTER_LIMIT
  // Openers
  const handleTextColorClick = (event) => setAnchorEl(event.currentTarget);
  const handleHighlightClick = (event) => setHighlightAnchor(event.currentTarget);

  // Closers
  const handleCloseAnchor = () => setAnchorEl(null);
  const handleHighlightClose = () => setHighlightAnchor(null);
  const [showLinkDialog, setShowLinkDialog] = useState(false);
  const [linkUrl, setLinkUrl] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: { levels: [1, 2, 3] },
      }),
      Underline,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      Link.configure({
        openOnClick: true,
        autolink: true,
        linkOnPaste: true,
        HTMLAttributes: {
          rel: 'noopener noreferrer',
          target: '_blank',
        },
      }),
      TextStyle,
      Color,
      Highlight.configure({ multicolor: true }),
    ],
    content: message || '',
    editorProps: {
      attributes: {
        style: `
          outline: none;
          min-height: 150px;
          border: none;
          font-family: Segoe UI, sans-serif;
          font-size: 14px;
          line-height: 1.6;
          color: #333;
          box-sizing: border-box;
        `,
      },
      handleDOMEvents: {
        beforeinput: (view, event) => {
          const currentLength = view.state.doc.textContent.length;
          const incoming = event.data || '';
          const nextLength = currentLength + incoming.length;
  
          if (
            nextLength > CHARACTER_LIMIT &&
            event.inputType !== 'deleteContentBackward'
          ) {
            event.preventDefault();
            return true;
          }
          return false;
        },
        paste: (view, event) => {
          const paste = (event.clipboardData || window.clipboardData).getData('text');
          const currentLength = view.state.doc.textContent.length;
          const nextLength = currentLength + paste.length;
  
          if (nextLength > CHARACTER_LIMIT) {
            event.preventDefault();
            return true;
          }
          return false;
        },
      },
    },
    onUpdate: _.debounce(({ editor }) => {
      const currentText = editor.getText();
      
      // Only proceed if the content actually changed
      if (prevMessageRef.current === currentText) return;
      prevMessageRef.current = currentText;
  
      if (currentText.length > CHARACTER_LIMIT) {
        setShowLimitWarning(true);
  
        const trimmedText = currentText.slice(0, CHARACTER_LIMIT);
        editor.commands.setContent(trimmedText, false); // no update loop
      } else {
        setShowLimitWarning(false);
  
        const html = editor.getHTML();
        prevMessageRef.current = html;
        onFieldChange('message', html);
      }
    }, 300) 
  });
  console.log("warning",showLimitWarning);
  

  // Handle external message prop changes
  useEffect(() => {
    if (editor && message !== null && message !== undefined) {
      // Update our ref to match the incoming message
      prevMessageRef.current = message;
      
      // Always set the content to ensure copy-paste works correctly
      // This won't cause infinite loops because we're using a proper condition in the dependency array
      editor.commands.setContent(message);
    }
  }, [editor, message]);

  useEffect(() => {
    // Count plain text characters
    const plainText = message?.replace(/<[^>]*>/g, '') || '';
    setCharCount(plainText.length);
  }, [message]);
  

  const handleSend = () => {
    if (to && subject) onSend();
  };

  const handleClose = () => setShowConfirmClose(true);
  const confirmClose = (confirm) => {
    if (confirm) onClose();
    setShowConfirmClose(false);
  };
  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Send Email</DialogTitle>
        <DialogContent>

          {/* To field */}
          <PlusControlledSelect
            label="To"
            name="to"
            value={to}
            options={contactOptions}
            required
            placeholder="To"
            error={!to}
            helperText={!to ? 'Recipient is required' : ''}
            handleChange={(e) => {
              onFieldChange('to', e.target.value);
            }}
            handleAddClick={() => {
              console.log("Plus clicked!");
            }}
          />
          <PlusControlledSelect 
            label={"CC"}
            name={"cc"}
            value={cc[0]}
            // options={supplierOptions}
            required
            placeholder="CC"
            error={!cc}
            helperText={!cc ? 'CC is required' : ''}
            handleChange={(e) => {
              onFieldChange('cc', e.target.value);
            }}
            handleAddClick={() => {
              console.log("Plus clicked!");
            }}
            />
          {/* Subject */}
          <CustomInput
            label="Subject"
            name="subject"
            value={subject}
            required
            onChange={(e) => onFieldChange('subject', e.target.value)}
            height={40}
          />

          {/* Attachment toggle */}
          <CustomInput
            label="Attach Credit Note PDF"
            name="attachment"
            type="checkbox"
            value={attachment}
            onChange={(e) => onFieldChange('attachment', e.target.checked)}
          />

        <Typography variant="subtitle2" gutterBottom>
          Email Template
        </Typography>
                  
        {editor && (
          <div style={{
            border: '1px solid #ccc',
            borderRadius: '4px',
            // background: '#f9f9f9',
            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)',
          }}>
            {/* Toolbar */}
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '6px',
              padding: '8px',
              background: '#eee',
              borderBottom: '1px solid #ccc',
            }}>
              <button onClick={() => editor.chain().focus().toggleBold().run()} style={{ border: 'none', background: 'none' }}><b>B</b></button>
              <button onClick={() => editor.chain().focus().toggleItalic().run()} style={{ border: 'none', background: 'none' }}><i>I</i></button>
              <button onClick={() => editor.chain().focus().toggleUnderline().run()} style={{ border: 'none', background: 'none' }}><u>U</u></button>
              <button onClick={() => editor.chain().focus().toggleBulletList().run()} style={{ border: 'none', background: 'none' }}><FormatListBulletedIcon /></button>
              <button onClick={() => editor.chain().focus().toggleOrderedList().run()} style={{ border: 'none', background: 'none' }}><FormatListNumberedIcon /></button>
              <button onClick={() => editor.chain().focus().setTextAlign('left').run()} style={{ border: 'none', background: 'none' }}><FormatAlignLeftIcon /></button>
              <button onClick={() => editor.chain().focus().setTextAlign('center').run()} style={{ border: 'none', background: 'none' }}><FormatAlignCenterIcon /></button>
              <button onClick={() => editor.chain().focus().setTextAlign('right').run()} style={{ border: 'none', background: 'none' }}><FormatAlignRightIcon /></button>
              <button onClick={() => editor.chain().focus().undo().run()} style={{ border: 'none', background: 'none' }}><UndoIcon /></button>
              <button onClick={() => editor.chain().focus().redo().run()} style={{ border: 'none', background: 'none' }}><RedoIcon /></button>
              <button onClick={() => {
                const currentUrl = editor.getAttributes('link').href || '';
                setLinkUrl(currentUrl);
                setShowLinkDialog(true);
              }}  style={{ border: 'none', background: 'none' }}><LinkIcon /></button>
              <button onClick={() => editor.chain().focus().unsetLink().run()} style={{ border: 'none', background: 'none' }}><LinkOffIcon /></button>
              <button onClick={handleTextColorClick} style={{ border: 'none', background: 'none' }}><PaletteIcon /></button>
              <button onClick={handleHighlightClick} style={{ border: 'none', background: 'none' }}>
                <span style={{ backgroundColor: '#ccc', padding: '2px 6px', borderRadius: '4px' }}>A</span>
              </button>
              <div style={{ position: 'relative' }}>
                <button onClick={() => setShowEmojiPicker(prev => !prev)} style={{ border: 'none', background: 'none' }}>😊</button>
                {showEmojiPicker && (
                  <div style={{ position: 'absolute', top: '40px', zIndex: 9999 }}>
                    <EmojiPicker onEmojiClick={(emojiData) => {
                      editor.chain().focus().insertContent(emojiData.emoji).run();
                      setShowEmojiPicker(false);
                    }} />
                  </div>
                )}
              </div>
            </div>
              
            {/* Editor Area */}
            <div style={{ padding: '8px', maxHeight: '200px', overflowY: 'auto' }}>
              <EditorContent editor={editor} />
            </div>
          </div>
        )}
        
        <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
          Character count: {charCount}/2000
        </Typography>
        {showLimitWarning && (
          <Typography variant="caption" color="error" style={{ marginTop: '4px' }}>
            Warning: Character limit exceeded! Extra characters were removed.
          </Typography>
        )}
        </DialogContent>

        <DialogActions sx={{ paddingX: 3 }}>
          <CustomButton onClick={handleClose} variant="contained" bgcolor={"grey"} color={'black'} text={'Cancel'} />
          <CustomButton
            onClick={handleSend}
            disabled={!to || !subject}
            img={<EmailOutlinedIcon sx={{ color: "black", font: "icon" }} />}
            variant="contained"
            bgcolor={"#95ABEB"}
            color={'black'}
            text={'Send'}
          />
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog open={showConfirmClose} onClose={() => confirmClose(false)}>
        <DialogTitle>Discard Email?</DialogTitle>
        <DialogContent>
          <Typography>
            If you leave, your message will not be saved or sent. Are you sure?
          </Typography>
        </DialogContent>
        <DialogActions>
        <Button 
          onClick={() => { 
            resetFields();         // Reset the fields
            confirmClose(true);    // Close the modal
          }} 
        color="primary">Yes</Button>
          <Button onClick={() => confirmClose(false)}>No</Button>
        </DialogActions>
      </Dialog>
      {showLinkDialog && (
        <Dialog open={showLinkDialog} onClose={() => setShowLinkDialog(false)}>
          <DialogTitle>Insert Link</DialogTitle>
          <DialogContent>
            <CustomInput
              label="URL"
              value={linkUrl}
              onChange={(e) => setLinkUrl(e.target.value)}
              placeholder="https://example.com"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowLinkDialog(false)}>Cancel</Button>
            <Button
              onClick={() => {
                if (!linkUrl.trim()) {
                  setShowLinkDialog(false);
                  return;
                }

                const selection = editor.state.selection;
                const hasSelection = selection.from !== selection.to;

                editor.chain().focus();

                if (hasSelection) {
                  // Apply link to selected text
                  editor.chain().extendMarkRange('link')
                    .setLink({ href: linkUrl.trim() })
                    .run();
                } else {
                  // Insert link as text
                  editor
                    .chain()
                    .insertContent(`<a href="${linkUrl.trim()}" target="_blank">${linkUrl.trim()}</a>`)
                    .run();
                }

                setShowLinkDialog(false);
              }}
              color="primary"
            >
              Apply
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* Text Color Picker Popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseAnchor}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div style={{ padding: 10, display: 'flex', gap: 8, flexWrap: 'wrap', maxWidth: 300 }}>
          {colors.map((color) => (
            <button
              key={color}
              onClick={() => {
                editor.chain().focus().setColor(color).run();
                handleCloseAnchor();
              }}
              style={{
                backgroundColor: color,
                width: 24,
                height: 24,
                border: '1px solid #ccc',
                borderRadius: '50%',
              }}
            />
          ))}
        </div>
      </Popover>

      {/* Highlight (Background) Picker */}
      <Popover
        open={Boolean(highlightAnchor)}
        anchorEl={highlightAnchor}
        onClose={handleHighlightClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div style={{ padding: 10, display: 'flex', gap: 8, flexWrap: 'wrap',  maxWidth: 300 }}>
          {colors.map((color) => (
            <button
              key={color}
              onClick={() => {
                editor.chain().focus().toggleHighlight({ color }).run();
                handleHighlightClose();
              }}
              style={{
                backgroundColor: color,
                width: 24,
                height: 24,
                border: '1px solid #ccc',
                borderRadius: '50%',
              }}
            />
          ))}
        </div>
      </Popover>
    </>
  );
};

export default EmailModal;